import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { ReactDOM } from "react";
import { Images } from "../../assets/common";
import { fullName, isOwnerId } from "../../constants/function";
import alexanander from "./alexander.jpg";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SellPopup from "../../components/SellPopup";
import { useTranslation } from "react-i18next";
const NftRank = ({
  data,
  isAuction,
  cancelSell,
  cancelAuction,
  handleBid,
  handleBuy,
  handleSell,
  handleAuction,
}) => {
  const { t } = useTranslation("common");
  const [show, setShow] = React.useState(false);
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={1} alignItems="center">
        <img
          className="avatar"
          src={data?.owner?.profileImg?.filePath || Images.default_user}
          alt=""
        />

        <Stack direction="column">
          <Typography className="fs-14">{fullName(data.owner)}</Typography>
          <Typography
            className={"fs-13 fade-text-60" + (!isAuction ? " _cp" : "")}
            onClick={() => (!isAuction ? setShow(true) : setShow(false))}
          >
            {t("nftDetail.nftRow.text1")}{" "}
            {data?.rank.length > 5
              ? `${data?.rank.slice(0, 10)}...`
              : typeof data?.rank === "number"
              ? data?.rank
              : data?.rank.join(",")}
          </Typography>
        </Stack>
      </Stack>
      {isAuction ? (
        <Stack>
          {isOwnerId(data?.owner?._id) ? (
            <Stack direction="row" spacing={2} alignItems="center">
              {data.onSale ? (
                <Button
                  onClick={() => cancelSell(data._id)}
                  variant="outlined"
                  endIcon={
                    <CloseOutlinedIcon
                      sx={{ marginLeft: "5px" }}
                      className="_cp"
                    />
                  }
                  className="fs-13 _cancel_button _hight30"
                >
                  {t("sellPopup.button2")}
                </Button>
              ) : null}
              {data.onAuction ? (
                <Button
                  onClick={() => cancelAuction(data._id)}
                  variant="outlined"
                  endIcon={
                    <CloseOutlinedIcon
                      sx={{ marginLeft: "5px" }}
                      className="_cp"
                    />
                  }
                  className="fs-13 _cancel_button _hight30"
                >
                  {t("nftDetail.nftRow.button2")}
                </Button>
              ) : null}
            </Stack>
          ) : (
            <Stack direction="row" spacing={2} alignItems="center">
              {data.onAuction ? (
                <Button
                  variant="outlined"
                  color="default"
                  className="fs-13 _hight30"
                  onClick={() => handleBid(data)}
                >
                  {t("nftDetail.nftRow.button3")}
                </Button>
              ) : null}
              {data.onSale ? (
                <Button
                  variant="contained"
                  color="primary"
                  className="fs-13 _hight30"
                  onClick={() => handleBuy(data)}
                >
                  {t("nftDetail.nftRow.button4")}
                </Button>
              ) : null}
            </Stack>
          )}
        </Stack>
      ) : null}
      {show ? (
        <SellPopup
          open={show}
          type="fraction"
          rank={0}
          fractions={data?.rank}
          isMaster={true}
          showOnly={true}
          handleClose={(amount) => setShow(false)}
        />
      ) : null}
    </Stack>
  );
};

export default NftRank;
